export default "__VITE_ASSET__D7Pi8oqd__"